import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const scrollbar: SxStyle = {
  maxHeight: '70vh',
  height: 'auto',
  overflowY: 'auto',
  padding: (p) => p.spacing(1.5),
};

export const popover: SxStyle = {
  width: (p) => p.spacing(46.5),
  mt: 1.5,
  overflow: 'visible',
};

export const box: SxStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  background: (p) => p.palette.common.white,
};

export const padding: SxStyle = {
  padding: (p) => p.spacing(0.5, 1, 1, 1),
};

export const listIcon: SxStyle = {
  padding: (p) => p.spacing(0.5),
  borderRadius: (p) => p.spacing(0.5),
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: (p) => p.palette.grey[300],
  color: (p) => p.palette.grey[500],
  cursor: 'pointer',
};

export const badge: SxStyle = {
  fontSize: (p) => p.typography.caption,
  background: (p) => p.palette.primary[100],
  color: (p) => p.palette.primary[500],
  width: (p) => p.spacing(2.5),
  height: (p) => p.spacing(2.5),
  fontWeight: 500,
  textAlign: 'center',
  borderRadius: '50%',

  ':hover': {
    cursor: 'pointer',
  },
};

export const socialIcon: SxStyle = {
  '&:hover': {
    color: (p) => p.palette.primary[300],
  },
};

export const companyDescription: SxStyle = { p: 0 };
